import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useLocation } from "react-router-dom";
import LocalStorageConstant from "../../constants/localstroage.constant";

const Signout: React.FC<any> = (props: {displaySignout:boolean,setDisplaySignout:any}) => {

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const closeHandler = () => {
    setIsModalVisible(false);
    props.setDisplaySignout(false);
  };
  const okHandler = () => {
    setIsModalVisible(false);
    localStorage.removeItem(LocalStorageConstant.accessToken);
    localStorage.removeItem(LocalStorageConstant.user);
    window.location.href = process.env.REACT_APP_LOGOUT_URL || "https://cnx-legacy-enterprise-portal-qa.azurewebsites.net/Account/Login?Logout=1"; 
  };

  useEffect(() => {
    setIsModalVisible(props.displaySignout);
  }, [props.displaySignout,props.setDisplaySignout]);

  return (
    <>
      {isModalVisible && <Dialog
        header={"Confirm Sign out"}
        visible={isModalVisible}
        style={{ width: "30vw" }}
        footer={
          <div>
            <Button
              label={"Ok"}
              className="text-black font-bold"
              onClick={okHandler}
            />
            <Button
              label="Cancel"
              onClick={closeHandler}
              className="text-black font-bold"
              style={{ backgroundColor: "#fff", color: "#000" }}
            />
          </div>
        }
        onHide={closeHandler}
        draggable={false}
        resizable={false}
      >
        <div className="col-md-6 pt-4" style={{marginLeft:"17px"}}>
          <label className="form-label"> Are you sure you want to Sign out? </label>
        </div>
      </Dialog>}
    </>
  );
};

export default Signout;
